export default __webpack_public_path__ + "images/EN.052c957.png";